import axios from "axios";

const axiosInstance = axios.create({
    // baseURL: "http://localhost:9000",
    // baseURL: "http://localhost:8080",
    // baseURL: "https://assignment6-blog-server-tanviranindo.onrender.com",
    baseURL: "https://assignment6-blog-server-tanviranindo.glitch.me",
});

export default axiosInstance;